import type { Components } from '@mui/material/styles';

import type { Theme } from '../theme/types';

export const MuiLink = {
  defaultProps: { underline: 'hover' },
} satisfies Components<Theme>['MuiLink'];
